export default function cartProduct({main, elm, on, state, publish}) {
	const cart = elm.closest('[data-cart]');

	main(_ => {
		on('click', '.remove', removeProduct);
		on('quantity-changed', changeQuantity);
	});

	const removeProduct = async function () {
		const {key} = state.get();

		const action = 'index.php?route=common/cart.remove';
		const params = new URLSearchParams();
		params.append('key', key);

		try {
			const product = await getProduct(key);

			const response = await fetch(action, {
				method: 'POST',
				body: params,
			});

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const result = await response.json();
			await cart.update();

			const formData = new FormData();
			Object.entries(product).forEach(([key, value]) => {
				formData.append(key, value);
			});
			const removeFromCartEvent = new CustomEvent('remove-from-cart', { detail: formData });
			document.dispatchEvent(removeFromCartEvent);
		} catch (e) {
			alert(`Error: ${e.message}`);
		}
	};

	const changeQuantity = async function (event, quantity) {
		const {key} = state.get();

		const action = 'index.php?route=checkout/cart.edit';
		const params = new URLSearchParams();
		params.append('key', key);
		params.append('quantity', quantity);

		try {
			const product = await getProduct(key);

			const response = await fetch(action, {
				method: 'POST',
				body: params,
			});

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			location.reload();

			// const result = await response.json();
			// await cart.update();
			//
			// const formData = new FormData();
			// Object.entries(product).forEach(([key, value]) => {
			// 	formData.append(key, value);
			// });
			// formData.append('new_quantity', quantity);
			// const changeQuantityCartEvent = new CustomEvent('change-quantity-cart', { detail: formData });
			// document.dispatchEvent(changeQuantityCartEvent);
		} catch (e) {
			alert(`Error: ${e.message}`);
		}
	}

	const getProduct = async function (key) {
		try {
			const response = await fetch(`index.php?route=extension/seo/seo/ecommerce.getProductData`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({key}),
			});

			if (!response.ok) {
				throw new Error(`Request failed: ${response.status}`);
			}

			const result = await response.json();

			return result.product;
		} catch (e) {
			console.error(e);
		}

		return null;
	}
};

export const model = {};
